module.exports = __webpack_public_path__ + "img/assisted-journaling-poster.384ec6c4.jpg";